import { render, staticRenderFns } from "./UserDetailsView.vue?vue&type=template&id=54d2afdc&scoped=true&"
import script from "./UserDetailsView.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsView.vue?vue&type=style&index=0&id=54d2afdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2afdc",
  null
  
)

export default component.exports